import TagsWorkOrderList from '@/components/Settings/Profiles/TagsWorkOrder/TagsWorkOrderList';
import TagsWorkOrderModal from '@/components/Settings/Profiles/TagsWorkOrder/TagsWorkOrderModal';
import { useDisclosure, useWindowSize } from '@/hooks';
import { PageProps } from '@/types/PageProps';
import { Button, Typography } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function TagsWorkOrderPage({ route }: PageProps) {
  const intl = useIntl();
  const { Title, Paragraph } = Typography;
  const { width } = useWindowSize();

  const [modalOpened, modalActions] = useDisclosure();

  return (
    <>
      <div className="page">
        <Helmet title={intl.formatMessage({ id: route.name })} />
        <div className="page-header">
          <Title level={4}>{intl.formatMessage({ id: route.name })}</Title>

          {!(width < 992) && (
            <Button type="primary" onClick={modalActions.open}>
              Criar Etiqueta
            </Button>
          )}
        </div>

        <Paragraph style={{ marginTop: '16px' }}>
          Etiquetas responsáveis por você identificar seus orçamentos da forma
          que desejar!
        </Paragraph>

        <TagsWorkOrderList />
      </div>

      <TagsWorkOrderModal open={modalOpened} onCancel={modalActions.close} />
    </>
  );
}
